import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { StatusAggregationActionTypes, StatusAggregationActions } from '../actions/status-aggregation.actions';
import * as featureActions from '../../index';
import {StatusService} from '../../../services/status.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';

@Injectable()
export class StatusAggregationEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private statusService = inject(StatusService);

  constructor() {}

  readStatusAggregations$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.StatusAggregationActionTypes.GetStatusAggregations),
    map((action: featureActions.GetStatusAggregations) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      if (isNaN(payload.dcode)) {
        return of(new featureActions.GetStatusAggregationsFail());
      }
      const params = { ...payload, otp: user.otp };
      return this.statusService.ReadDeviceStatusPeak(params).pipe(
        map((res: any) => {
          if (res.result) {
            const body = (Object.keys(res.msg.body).length === 0) ? [] : res.msg.body;
            return new featureActions.LoadStatusAggregations(body);
          } else {
            return new featureActions.GetStatusAggregationsFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => of(new featureActions.GetStatusAggregationsFail()))
      );
    })
  ));



}